import { replaceImgSrcWithProxy } from '../../replaceImgSrcWithProxy';
import { ITextChatImage } from './../../model/ITextChatMessage';

export function filterImagesForTextChat(images: ITextChatImage[]) {
    return (images || []).filter(image => {
        if (image && image.src) {
            return image.src.match(/\.(jpg|jpeg|png|gif|svg|webp)$/i);
        }
        return null;
    });
}

export function filterReachableImages(images, proxyImgDomain) {
    const reachableImages = [];
    const imagePromises = images.map((url) => {
        return checkImageReachable(replaceImgSrcWithProxy(url, proxyImgDomain))
            .then((url) => reachableImages.push(url))
            .catch(() => { })
    });

    return Promise.all(imagePromises).then(() => reachableImages);
}

function checkImageReachable(url) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(url);
        img.onerror = () => reject(url);
        img.src = url;
    });
}